/* eslint-disable react-hooks/exhaustive-deps */
import { IProduct_Category_Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { useIsMobile } from "@/hooks/useIsMobile";
import { RefObject, useEffect, useState } from "react";

export const useGetCategoryAdvanceStyle = (
  customize: IProduct_Category_Config_Customize,
  lebleRef: RefObject<HTMLDivElement | null>,
) => {
  const {
    gap: Pc_gap,
    gap_mobile,
    background_color,
    font_size,
    font_size_mobile,
    height,
    height_mobile,
    width,
    width_mobile,
  } = customize ?? {};
  const mobile = useIsMobile();
  const [lableHeight, setLableHeight] = useState(0);
  useEffect(() => {
    if (!lebleRef?.current) return;
    setLableHeight(lebleRef?.current?.clientHeight);
  }, []);
  const advanceFontSize = (mobile ? font_size_mobile : font_size) * 16;
  const gap = mobile ? gap_mobile : Pc_gap;
  const customStyleMolie: React.CSSProperties = {
    height: height_mobile,
    width: width_mobile,
    backgroundColor: background_color,
    flexDirection: "column",
    gap,
    padding: 8,
  };
  const customStylePc: React.CSSProperties = {
    height: height,
    width: width,
    backgroundColor: background_color,
    flexDirection: "column",
    gap,
    padding: 16,
  };
  const advancefullSize: React.CSSProperties = {
    width: `calc(100% - ${lableHeight + gap}px)`,
    height: `calc(100% - ${lableHeight + gap}px)`,
  };
  const advanceStyle = mobile ? customStyleMolie : customStylePc;
  return {
    advancefullSize,
    advanceStyle,
    advanceFontSize,
  };
};
